"use strict";
exports.__esModule = true;
var BaseModel = (function () {
    function BaseModel() {
    }
    BaseModel.prototype.parse = function (entity) {
        var _this = this;
        Object.keys(this).forEach(function (key) {
            if (entity[key] != null) {
                _this[key] = entity[key];
            }
        });
        return this;
    };
    return BaseModel;
}());
exports["default"] = BaseModel;



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/BaseModel.js
// module id = ../model/dist/models/BaseModel.js
// module chunks = main